export const MESSAGE_SIZE = 20

export const calendarRange = {
  MIN_DATE: 150,
  MAX_DATE: 150
}
